import { memo } from 'react';
import { ITournament } from '@zmedia/bm-soccer-ui/interface';
import { ArrayUtils } from '@zmedia/bm-soccer-ui/utils';
import { Element, Image, RouterLink, Title } from '@zmedia/bm-soccer-ui/components';
import { URL_SOCCER_PAGE } from '@zmedia/bm-soccer-ui/modules/shared';
import { Matches } from '../match';
import Empty from '../shared/components/Empty';
import styles from './style.module.scss';

interface IProps {
    groups: ITournament[];
}

export function Group({ groups = [] }: IProps) {
    const renderItem = (item: any, index: number) => {
        const path =
            typeof item.path === 'string' ? item.path : item?.tournament?.path;
        return (
            <Element className={styles['group-matches']} key={index}>
                <RouterLink
                    to={`${URL_SOCCER_PAGE.SUBPATH}${path}`}
                    className={styles['group-header']}
                    title={item.name}
                >
                    <Image src={item.logo} alt={"Giải đấu " + item.name} />
                    <Title>{item.name}</Title>
                </RouterLink>
                <Matches matches={item.matches} />
            </Element>
        );
    };

    const renderItems = () => {
        return groups.map((item, index) => {
            return renderItem(item, index);
        });
    };

    if (ArrayUtils.isEmpty(groups)) {
        return <Empty content="Chưa có trận đấu nào"></Empty>;
    }

    return (
        <Element className={styles['match-group-home']}>
            {renderItems()}
        </Element>
    );
}

export default memo(Group);
